/**
 * Production Order Status Constants
 * Maps backend status values to Chinese display labels
 */

export const PRODUCTION_STATUS_MAP = {
  'draft': { label: '草稿', color: 'default' },
  'released': { label: '已发布', color: 'info' },
  'in_progress': { label: '进行中', color: 'warning' },
  'completed': { label: '已完成', color: 'success' },
  'cancelled': { label: '已取消', color: 'error' }
};

/**
 * Get display label for a production status
 * @param {string} status - Backend status value
 * @returns {string} - Chinese display label
 */
export function getProductionStatusLabel(status) {
  if (!status) return '-';
  return PRODUCTION_STATUS_MAP[status]?.label || status;
}

/**
 * Get display config (label + color) for a production status
 * @param {string} status - Backend status value
 * @returns {Object} - { label, color }
 */
export function getProductionStatusConfig(status) {
  if (!status) return { label: '-', color: 'default' };
  return PRODUCTION_STATUS_MAP[status] || { label: status, color: 'default' };
}
